import React, { useEffect, useState, useContext } from "react";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import DateTimePicker from "react-datetime-picker";
import FileDownload from "js-file-download";
import Utils from "./../../common/Utils";
import { Row, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge, Tab, Tabs } from "react-bootstrap";
import ReportBar from "./reportsBar";
import { UserContext } from "../../common";

export const options = {
  is3D: true,
  sliceVisibilityThreshold: 0,
  legend: { position: "none" },
  colors: ["#090d57", "#77d773", "#ffbe00", "#848484", "#1f9656"],
};

const assignedDays = () => _.get(Utils.getUserData(),'assigndays',180);

const Reports = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ jobs: false, tasks: false, attendance: false, holidays: false });
  const [teamMembers, setTeamMembers] = useState([]);
  const [listData, setListData] = useState({ label: "", data: [], loading: false, show: false });
  const [jCats, setJCats] = useState([]);
  const {userData} = useContext(UserContext);
  const [filter, setFilter] = useState({
    tab: "jobs",
    jcat: "",
    user: "",
    branch: "",
    jobmode: "recent",
    fromDt: moment().startOf('year').toDate(),
    toDt: moment().toDate(),
  });

  const fetchJCats = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("jobs/jobcategories"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setJCats(res.data.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(fetchJCats, []);

  const isReportVisible = (tab = false) => {
    if (!tab) tab = _.get(filter, "tab", "jobs");
    return (
      (tab === "jobs" && parseInt(_.get(stats, "jobs.total_jobs", 0)) > 0) ||
      (tab === "tasks" && parseInt(_.get(stats, "tasks.total_tasks", 0)) > 0) ||
      (tab === "attendance" && parseInt(_.get(stats, "attendance.users", 0)) > 0) ||
      (tab === "holidays" && parseInt(_.get(stats, "holidays.total_users", 0)) > 0)
    );
  };

  const getReportFromData = (listmode) => {
    let formData = new FormData();

    if (filter.fromDt != "" && moment(filter.fromDt).isValid()) {
      formData.set("dt_from", moment(filter.fromDt).format("YYYY-MM-DD"));
    }

    if (filter.toDt != "" && moment(filter.toDt).isValid()) {
      formData.set("dt_to", moment(filter.toDt).format("YYYY-MM-DD"));
    }

    if (filter.tab === "jobs") {
      formData.set("jobmode", filter.jobmode);
    }

    formData.set("tab", filter.tab);
    formData.set("user_id", filter.user);
    formData.set("branch_id", filter.branch);
    formData.set("listmode", listmode);

    return formData;
  };

  const fetchReportStats = () => {
    setListData({ ...listData, show: false});
    setLoading(true);
    axios
      .post(Utils.apiUrl("reports/status"), getReportFromData(), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          if (filter.tab == "jobs") {
            setStats({ ...stats, jobs: res.data.status });
          } else if (filter.tab == "tasks") {
            setStats({ ...stats, tasks: res.data.status });
          } else if (filter.tab == "attendance") {
            setStats({ ...stats, attendance: res.data.status });
          } else if (filter.tab == "holidays") {
            setStats({ ...stats, holidays: res.data.status });
          }
        } else {
          window.alert(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      })
      .finally((err) => {
        setLoading(false);
      });

    return false;
  };
  useEffect(fetchReportStats, [filter]);

  const fetchReportListing = ({ listmode, label }) => {
    setListData({ ...listData, loading: true, show: true, listmode: listmode, label: label });
    axios
      .post(Utils.apiUrl("reports/listing"), getReportFromData(listmode), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setListData({ ...listData, loading: false, data: res.data.data, show: true, label: label });
        } else {
          window.alert(res.data.message);
          setListData({ ...listData, loading: false, show: true, label: label });
        }
      })
      .catch((err) => {
        setListData({ ...listData, loading: false, show: true, label: label });
        console.log(err);
      });
  };

  const fetchTeamMembers = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("tasks/fetchteammembers"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setTeamMembers(_.get(res, "data.teamMembers", []));
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };
  useEffect(fetchTeamMembers, []);

  const exportReport = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    let formData = new FormData(frm);

    if (filter.fromDt != "" && moment(filter.fromDt).isValid()) {
      formData.set("dt_from", moment(filter.fromDt).format("YYYY-MM-DD 00:00:00"));
    }

    if (filter.toDt != "" && moment(filter.toDt).isValid()) {
      formData.set("dt_to", moment(filter.toDt).format("YYYY-MM-DD 23:59:59"));
    }

    setLoading(true);
    axios
      .post(Utils.apiUrl("reports/download"), formData, Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          var data = _.map(res.data.data, (d) => (_.isArray(d) ? d.join(",") : d)).join("\n");
          var data = new Blob([data], { type: "text/csv" });
          FileDownload(data, `${filter.tab}-report.csv`);
        } else {
          window.alert(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });

    return false;
  };

  const showJobsReport = () => {
    return (
      <ReportBar
        bardata={[
          ["Status", "Number of Jobs",false],
          ["TOTAL ASSIGNED", Math.max(0, Number(stats.jobs.total_assigned || 0)),false],
          ["COMPLETED", Math.max(0, Number(stats.jobs.completed_total || 0)),true],
          ["PENDING", Math.max(0, Number(stats.jobs.pending_total || 0)),true],
          ["MARKED NA", Math.max(0, Number(stats.jobs.na_total || 0)),true],
          ["Required Evidence", Math.max(0, Number(stats.jobs.total_rev || 0)),false],
        ]}
        options={options}
        clickData={["total_assigned", "completed_total", "pending_total", "na_total"]}
        onClick={fetchReportListing}
      />
    );
  };

  const showTasksReport = () => {
    return (
      <ReportBar
        bardata={[
          ["Status", "Number of Tasks",false],
          ["TOTAL ASSIGNED", Math.max(0, Number(stats.tasks.total_assigned || 0)),false],
          ["COMPLETED", Math.max(0, Number(stats.tasks.completed_total || 0)),true],
          ["OVERDUE/PENDING", Math.max(0, Number(stats.tasks.pending_total || 0)),true],
          ["MARKED NA", Math.max(0, Number(stats.tasks.na_total || 0)),true],
        ]}
        options={options}
        clickData={["total_assigned", "completed_total", "pending_total", "na_total"]}
        onClick={fetchReportListing}
      />
    );
  };

  const showAttnReport = () => {
    return (
      <ReportBar
        bardata={[
          ["Status", "Attendance",false],
          ["TOTAL HOURS", Math.max(0, Number(stats.attendance.ontime || 0)) + Math.max(0, Number(stats.attendance.differed || 0)),false],
          ["ONTIME", Math.max(0, Number(stats.attendance.ontime || 0)),true],
          ["DIFFERED TIME", Math.max(0, Number(stats.attendance.differed || 0)),true],
          ["PAYROLL HOURS", stats.attendance.payroll,false],
        ]}
        options={{...options,colors: ["#070d59","#77d773","#c20000","#848484"]}}
        clickData={["total", "ontime", "differed"]}
        onClick={fetchReportListing}
      />
    );
  };

  const showHolidaysReport = () => {

    
    let colors = ["#090d57"], clickdata = ["total"];
    let totalhrs = Math.max(0,Number(stats.holidays.approved || 0))+Math.max(0, Number(stats.holidays.unpaid || 0))+Math.max(0, Number(stats.holidays.pending || 0));
    let bardata = [["Status", "Number of Holidays",false]];

    if(filter.user != '' && parseInt(filter.user) > 0){
      //colors=[...colors,"#5893d4"];
      //clickdata = ['available'];
      //bardata=[...bardata,["TOTAL", totalhrs,false],["AVAILABLE", Math.max(0, Number(stats.holidays.available || 0)),false]];
      bardata=[...bardata,["TOTAL", totalhrs,false]];
    }else{
      bardata=[...bardata,["TOTAL", totalhrs,false]];
    }

    colors=[...colors,"#77d773","#c20000","#ffbf00"];
    clickdata=[...clickdata,"approved", "unpaid", "pending"];

    bardata=[...bardata,
      ["APPROVED", Math.max(0, Number(stats.holidays.approved || 0)),true],
      ["UNPAID", Math.max(0, Number(stats.holidays.unpaid || 0)),true],
      ["PENDING", Math.max(0, Number(stats.holidays.pending || 0)),true],
    ];
//console.log(bardata,colors,clickdata);
    if(totalhrs === 0){
      return <Alert variant="warning" className="my-3 p-3 text-center">No Stats found!</Alert>;
    }
    return (
      <ReportBar
        bardata={bardata}
        options={{...options,colors: colors}}
        clickData={clickdata}
        onClick={fetchReportListing}
      />
    );
  };

  const prepareListData = () => {
    let data = [];
    if (parseInt(_.get(listData, "data.length", 0)) > 0) {
      if (parseInt(filter.user) > 0) {
        data = listData.data.slice(8);
      } else {
        data = listData.data;
      }
    }
    return data;
  };

  const renderReportListModal = () => {
    return (
      <Modal
        size="fullscreen"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={true}
        onHide={() => setListData({ ...listData, show: false })}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {filter.tab.toUpperCase()} - {listData.label}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderReportList()}
        </Modal.Body>
      </Modal>
    );
  };

  const renderReportList = () => {
    return <>
      <div className="text-end muted">*only first 50 records</div>
          {listData.loading && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Fetching Reports data..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {!listData.loading && (
            <>
              {listData.data.length === 0 && (
                <Alert variant="warning" className="p-3">
                  <b>No Records Found!</b>
                </Alert>
              )}
              {prepareListData().length > 0 && <Table striped={true} bordered={true} cellSpacing={2}>
                <thead>
                  <tr><th>Sl.</th>
                  {prepareListData()[0].map(label =><th>{label}</th>)}  
                  </tr>
                </thead>
                <tbody>
                {prepareListData().map((rec, idx1) => (
                  <tr key={idx1}>
                    {idx1 > 0  &&<td><Badge className="bg-info text-dark">{idx1}</Badge></td>}
                    {idx1 > 0 && rec.map((r, idx2) => <td key={idx2}>
                        <div style={{ maxWidth: 350 }}>{r}</div>
                      </td>)}
                  </tr>
                ))}
                </tbody>
              </Table>}
            </>
          )}
    </>;
  };

  const reportList = (showlist) => {
    
    if(showlist){
      fetchReportListing(filter.tab=='holidays' ? 
        {label: "TOTAL APPLIED", listmode: "total"} : 
        filter.tab=='attendance' ? {label: "TOTAL ATTENDANCE", listmode: "total"}
        : {label: "TOTAL ASSIGNED", listmode: "total_assigned"});
    }else{
      setListData({ ...listData, show: false });
    }
  };

  const getAllMembers = () => {
    if (filter.branch != "") {
      return _.filter(teamMembers, (m) => parseInt(m.branch_id) == parseInt(filter.branch));
    }
    return teamMembers;
  }

  return (
    <>
      <div className="mt-4">
        {loading && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">Fetching Reports</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}

        {!loading && (
          <>
            <Tabs defaultActiveKey={filter.tab} fill onSelect={(k) => {setFilter({ ...filter, tab: k });setListData({...listData,show: false})}} className="report-tabs">
              <Tab eventKey="jobs" title="Jobs" />
              <Tab eventKey="tasks" title="Tasks" />
              <Tab eventKey="attendance" title="Attendance" />
              <Tab eventKey="holidays" title="Holidays" />
            </Tabs>
            <Row>
              <Col>
                <Card border="light" className="report-box shadow table-section p-sm-3 border-0 bottomRoundedBox mx-1 mx-sm-0">
                  <Card.Body>
                    <h1 className="mb-4">
                      {_.upperFirst(filter.tab)} Report
                      <select
                          className="form-control-select shadow-cst filters px-2"
                          value={filter.branch}
                          onChange={(e) => setFilter({ ...filter, branch: e.currentTarget.value })}
                        >
                          <option value="">All Branches</option>
                          {_.uniqBy(_.map(teamMembers, (member) => _.pick(member,['branch_id','branch'])),'branch_id').map(b => <option key={b.branch_id} value={b.branch_id}>{b.branch}</option>)}
                        </select>
                      {filter.tab === "jobs" && (<> 
                        <select
                          className="form-control-select shadow-cst filters px-2"
                          value={filter.jobmode}
                          onChange={(e) => setFilter({ ...filter, jobmode: e.currentTarget.value })}
                        >
                          <option value="recent">Recent Jobs</option>
                          <option value="archived">Archived Jobs</option>
                        </select>
                        <Alert variant="warning" className="p-1 m-2 m-sm-1">
                          <img src={`${process.env.PUBLIC_URL}/images/circle.png`} alt="Information" width="20" className="mx-2" /> 
                          {filter.jobmode==='recent' && <span>To see data past {assignedDays()} days or older choose Archived Jobs dropdown option.</span>}
                          {filter.jobmode==='archived' && <span>To see data upto {assignedDays()} days choose Recent Jobs dropdown option.</span>}
                        </Alert>
                        </>)}
                    </h1>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Form.Label>Select Team Member:</Form.Label>
                        <select
                          className="form-control form-control-select form-select shadow-cst filters"
                          value={filter.user}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              user: e.currentTarget.value,
                            })
                          }
                        >
                          <option value="">All Members</option>
                          {getAllMembers().map((tm) => (
                            <option key={tm.id} value={tm.id}>
                              {tm.title} {tm.name}
                            </option>
                          ))}
                        </select>
                      </Col>

                      <Col xs={12} sm={6} className="my-4">
                        <Form.Label>Select Dates:</Form.Label>
                        <div className="form-control form-control-select form-select filters py-2 px-0 px-sm-2">
                          <div class="d-flex">
                            <DateTimePicker
                              dayPlaceholder="dd"
                              monthPlaceholder="mm"
                              yearPlaceholder="yyyy"
                              format="y-MM-dd"
                              minDate={filter.tab=='jobs' ? (filter.jobmode === "recent" ? moment().add(-assignedDays(),'days').toDate() : false) : false}
                              maxDate={filter.tab=='jobs' ? (filter.jobmode === "archived" ? moment().add(-assignedDays(),'days'): moment()).toDate() : false}
                              className="me-1"
                              onChange={(v) => setFilter({ ...filter, fromDt: v })}
                              value={filter.fromDt}
                            />
                            <span className="px-2 d-none d-sm-inline">to</span>
                            <DateTimePicker
                              dayPlaceholder="dd"
                              monthPlaceholder="mm"
                              yearPlaceholder="yyyy"
                              minDate={filter.tab=='jobs' ? (filter.jobmode === "recent" ? moment().add(-assignedDays(),'days').toDate() : false) : false}
                              maxDate={filter.tab=='jobs' ? (filter.jobmode === "archived" ? moment().add(-assignedDays(),'days'): moment()).toDate() : false}
                              format="y-MM-dd"
                              onChange={(v) => setFilter({ ...filter, toDt: v })}
                              value={filter.toDt}
                            />
                          </div>
                        </div>
                      </Col>

                      {filter.tab === "jobs" && false && (
                        <Col xs={12} sm={6} className="my-4">
                          <Form.Label>Select Job Category:</Form.Label>
                          <select
                            className="form-control form-control-select form-select shadow-cst filters"
                            value={filter.jcat}
                            onChange={(e) =>
                              setFilter({
                                ...filter,
                                jcat: e.currentTarget.value,
                              })
                            }
                          >
                            <option value="">All Categories</option>
                            {jCats.map((jc) => (
                              <option key={jc.id} value={jc.id}>
                                {jc.value}
                              </option>
                            ))}
                          </select>
                        </Col>
                      )}
                    </Row>
                    {_.get(process.env, "REACT_APP_REPORT_HIDE", "false") === "false" && (
                      <Row>
                        <Col xs={12} sm={12} style={{minHeight: "550px"}}>

                        <Tabs className="mb-1" fill activeKey={listData.show ? "list" : "stats"} onSelect={(k) => reportList(k=="list")}>
                          <Tab eventKey="stats" title="Stats" active={!listData.show} />
                          <Tab eventKey="list" title="List" active={listData.show} />
                        </Tabs>
                          {listData.show === false && <>
                            {filter.tab === "jobs" && isReportVisible("jobs") && showJobsReport()}
                            {filter.tab === "tasks" && isReportVisible("tasks") && showTasksReport()}
                            {filter.tab === "attendance" && isReportVisible("attendance") && showAttnReport()}
                            {filter.tab === "holidays" && isReportVisible("holidays") && showHolidaysReport()}
                            {isReportVisible() === false && (
                              <Alert variant="warning" className="text-center">
                                <b>No Stats found!</b>
                              </Alert>
                            )}
                          </>}
                          {isReportVisible() && listData.show && <div className="report-listing">{renderReportList()}</div>}
                        </Col>
                      </Row>
                    )}

                    
                    {isReportVisible() && (
                      <Row>
                        <Col xs={12} className="d-flex justify-content-end">
                          <form action="/admin/api/reports/download" method="post" onSubmit={exportReport}>
                            <input type="hidden" name="tab" value={filter.tab} />
                            <input type="hidden" name="jcat" value={filter.jcat} />
                            <input type="hidden" name="user" value={filter.user} />
                            {_.get(userData,'is_super_user',false) && <input type="hidden" name="branch_id" value={filter.branch} />}
                            <input type="hidden" name="jobmode" value={filter.jobmode} />
                            <input type="hidden" name="dt_from" value={filter.fromDt} />
                            <input type="hidden" name="dt_to" value={filter.toDt} />
                            {listData.show && <input type="hidden" name="listmode" value={listData.listmode} />}
                            <Button type="submit" variant="primary" className="style1 radius-both shadow-cst p-0 text-light p-2 px-5">
                              Export {_.upperFirst(filter.tab)} {listData.show && <>- {_.upperFirst(listData.label)}</>}
                            </Button>
                          </form>
                        </Col>
                      </Row>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default Reports;
